import React, { useState, useEffect } from 'react';
import ArtworkCard from './ArtworkCard';
import QuestionForm from './QuestionForm';
import { API_URL } from '../config/apiConfig';
import artworksData from '../data/artworks.json';

function ArtworkList() {
  const [currentIndex, setCurrentIndex] = useState(
    parseInt(localStorage.getItem("currentIndex")) || 0
  );

  const [answers, setAnswers] = useState(
    JSON.parse(localStorage.getItem("responses")) || []
  );

  const [canGoNext, setCanGoNext] = useState(false);
  const [generatedImage, setGeneratedImage] = useState(null);
  const [fadeOpacity, setFadeOpacity] = useState(1);
  const [generatedOpacity, setGeneratedOpacity] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false); // 🔥 Nuevo estado para detectar si se completó el flujo

  // Guardar en localStorage cuando cambie `currentIndex`
  useEffect(() => {
    localStorage.setItem("currentIndex", currentIndex);
  }, [currentIndex]);

  // Guardar en localStorage cuando cambien las respuestas
  useEffect(() => {
    localStorage.setItem("responses", JSON.stringify(answers));
  }, [answers]);

  const handleAnswer = (answer) => {
    const newAnswers = [...answers];
    newAnswers[currentIndex] = {
      question: currentArtwork.question.text || "Sin pregunta",
      answer,
    };
    setAnswers(newAnswers);
  };

  const handleNext = () => {
    if (canGoNext) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
      setCanGoNext(false);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
      setCanGoNext(true);
    }
  };

  const handleReveal = async () => {
    setIsProcessing(true);
    setGeneratedImage(null);
    setFadeOpacity(1);
    setGeneratedOpacity(0);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        body: JSON.stringify({ answers }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Error al enviar respuestas.');
      }

      const data = await response.json();
      if (data.path) {
        setGeneratedImage(data.path);
        setIsCompleted(true); // 🔥 Marcar como completado cuando la imagen generada llega
      }
    } catch (err) {
      alert('Error al enviar respuestas.');
    } finally {
      setIsProcessing(false);
    }
  };

  const handleReset = () => {
    // 🔥 Restablecer el estado
    setCurrentIndex(0);
    setAnswers([]);
    setGeneratedImage(null);
    setFadeOpacity(1);
    setGeneratedOpacity(0);
    setIsCompleted(false);

    // 🔥 Limpiar localStorage
    localStorage.removeItem("currentIndex");
    localStorage.removeItem("responses");
  };

  useEffect(() => {
    if (generatedImage) {
      let opacity = 0;
      const interval = setInterval(() => {
        opacity += 0.05;
        setGeneratedOpacity(opacity);
        setFadeOpacity(1 - opacity);
        if (opacity >= 1) clearInterval(interval);
      }, 100);
    }
  }, [generatedImage]);

  const currentArtwork = artworksData[Math.min(currentIndex, artworksData.length - 1)];

  return (
    <div className="container">
      <ArtworkCard 
        artwork={{
          ...currentArtwork,
          image: currentArtwork.image,
          generatedImage: generatedImage,
        }} 
        fadeOpacity={currentIndex === artworksData.length - 1 ? fadeOpacity : 1}
        generatedOpacity={currentIndex === artworksData.length - 1 ? generatedOpacity : 0}
        isFinal={currentIndex === artworksData.length - 1}
      />

      {currentIndex < artworksData.length - 1 && (
        <QuestionForm
          question={currentArtwork.question}
          onAnswer={handleAnswer}
          canGoNext={canGoNext}
          setCanGoNext={setCanGoNext}
        />
      )}

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
        <button onClick={handleBack} disabled={currentIndex === 0}>
          Atrás
        </button>
        
        {currentIndex === artworksData.length - 1 ? (
          isCompleted ? (
            <button onClick={handleReset}>🔄 Reiniciar</button>
          ) : (
            <button onClick={handleReveal} disabled={isProcessing}>
              {isProcessing ? "Procesando..." : "Revelar"}
            </button>
          )
        ) : (
          <button onClick={handleNext} disabled={!canGoNext}>
            Siguiente
          </button>
        )}
      </div>
    </div>
  );
}

export default ArtworkList;
